import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { Lang } from '../types';
import _ from 'lodash';
import reducers from "../reducers";
import {persistCombineReducers} from "redux-persist";
import slices from "./index";
import { isMobile, isTablet } from "../modules/helpers";
import storage from "redux-persist/lib/storage";
import { persistReducer } from 'redux-persist';

interface InitialStateType {
    generalInfo: any,
    searchNameInfo: any,
    top10NamesByYearInfo: any,
    top10NameWordsByYearInfo: any,
    top5NewBornNameWordsByYearInfo: any,
    isLoading: boolean,
    lang: Lang | null,
    langMap: any,
    newsDialogParam: any,
    size: string,
    isMobile: boolean,
    isTablet: boolean,
}
const initialState = {
    generalInfo: null,
    searchNameInfo: null,
    isLoading: false,
    lang: null,
    langMap: _.reduce(Object.values(Lang), (pre: any, cur: string) => {
        switch (cur) {
            case Lang.zhMO:
                pre[cur] = '繁';
                break;
            case Lang.zhCN:
                pre[cur] = '简';
                break;
            case Lang.ptPT:
                pre[cur] = 'PT';
                break;
            case Lang.enUS:
                pre[cur] = 'EN';
                break;
            default:
                pre[cur] = cur;
        }
        return pre;
    }, {}),
    newsDialogParam: {
        isOpen: false,
        title: '',
        content: '',
        date: ''
    },
    size: '',
    isMobile: true
} as InitialStateType;

export const storeSlice = createSlice({
    name: 'storeSlice',
    initialState: initialState,
    reducers: {
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            let isLoading = action.payload;
            state.isLoading = isLoading;
        },
        setLang: (state, action: PayloadAction<Lang>) => {
            let lang = action.payload;
            state.lang = lang;
        },
        getNameStatisticGeneralInfo: (state) => {
        },
        setNameStatisticGeneralInfo: (state, action: PayloadAction<any>) => {
            let generalInfo = action.payload;
            state.generalInfo = generalInfo;
            state.top10NamesByYearInfo = { top10NamesByYear: generalInfo.top10NamesByYear };
            state.top10NameWordsByYearInfo = { top10NameWordsByYear: generalInfo.top10NameWordsByYear };
            state.top5NewBornNameWordsByYearInfo = { top5NewBornNameWordsByYear: generalInfo.top5NewBornNameWordsByYear };
        },
        getSearchNameInfo: (state, action: PayloadAction<any>) => {
        },
        setSearchNameInfo: (state, action: PayloadAction<any>) => {
            let searchNameInfo = action.payload;
            state.searchNameInfo = searchNameInfo;
        },
        getTop10NamesByYearInfo: (state, action: PayloadAction<any>) => {
        },
        setTop10NamesByYearInfo: (state, action: PayloadAction<any>) => {
            let top10NamesByYearInfo = action.payload;
            state.top10NamesByYearInfo = top10NamesByYearInfo;
        },
        getTop10NameWordsByYearInfo: (state, action: PayloadAction<any>) => {
        },
        setTop10NameWordsByYearInfo: (state, action: PayloadAction<any>) => {
            let top10NameWordsByYearInfo = action.payload;
            state.top10NameWordsByYearInfo = top10NameWordsByYearInfo;
        },
        getTop5NewBornNameWordsByYearInfo: (state, action: PayloadAction<any>) => {
        },
        setTop5NewBornNameWordsByYearInfo: (state, action: PayloadAction<any>) => {
            let top5NewBornNameWordsByYearInfo = action.payload;
            state.top5NewBornNameWordsByYearInfo = top5NewBornNameWordsByYearInfo;
        },
        setNewsDialogParam: (state, action: PayloadAction<any>) => {
            let newsDialogParam = action.payload;
            state.newsDialogParam = newsDialogParam;
        },
        setSize: (state, action: PayloadAction<string>) => {
            let size = action.payload;
            let isMobileParam = isMobile(size);
            let isTabletParam = isTablet(size);
            state.size = size;
            state.isMobile = isMobileParam;
            state.isTablet = isTabletParam;
        },
    },
});

export const {
    setIsLoading,
    setLang,
    getNameStatisticGeneralInfo,
    setNameStatisticGeneralInfo,
    getSearchNameInfo,
    setSearchNameInfo,
    getTop10NamesByYearInfo,
    setTop10NamesByYearInfo,
    getTop10NameWordsByYearInfo,
    setTop10NameWordsByYearInfo,
    getTop5NewBornNameWordsByYearInfo,
    setTop5NewBornNameWordsByYearInfo,
    setSize
} = storeSlice.actions


const storePersistConfig = {
    key: 'store',
    storage,
    whitelist: []
}

const persistedReducer = persistReducer(storePersistConfig, storeSlice.reducer);

export default persistedReducer
